var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80608 13.8737V9.50778C9.83086 8.57395 10.4736 7.22779 10.4736 5.72397C10.4797 2.88611 8.1997 0.606123 5.37397 0.606123C2.54824 0.606123 0.274317 2.88611 0.274317 5.72397C0.274317 7.2763 0.959526 8.66491 2.04495 9.59874L2.05101 13.8737C2.05101 14.3528 2.34207 14.5711 2.69377 14.5711C2.94845 14.5711 3.13643 14.4437 3.33654 14.2497L5.21025 12.3881C5.28908 12.3093 5.36184 12.2729 5.42855 12.2729C5.49525 12.2729 5.56195 12.3093 5.64684 12.3881L7.52056 14.2497C7.72066 14.4437 7.9147 14.5711 8.16332 14.5711C8.52108 14.5711 8.80608 14.3528 8.80608 13.8737ZM5.38004 9.44108C3.30622 9.44108 1.68112 7.7796 1.68112 5.72397C1.68112 3.66228 3.30622 1.99473 5.38004 1.99473C7.44779 1.99473 9.07289 3.66228 9.07895 5.72397C9.07895 7.7796 7.44779 9.44714 5.38004 9.44108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointIcon);
export default __webpack_public_path__ + "static/media/point_icon.2390f6184a2e9f05231fcd17260f2bd3.svg";
export { ForwardRef as ReactComponent };